export enum RequestStatus {
  Open = 'open',
  Confirmed = 'confirmed',
  Done = 'done',
  Refunded = 'refunded',
}
